var _templateObject = _taggedTemplateLiteralLoose(['\n  background-image: linear-gradient(45deg, ', ' 0%, ', ' 100%);\n  color: ', ';\n  height: 48px;\n  width: auto;\n  margin: ', ' ', ' ', ' ', ';\n  padding-left: ', ';\n  border-radius: ', ';\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  transition: all 1500ms ease-in-out;\n  span {\n    display: inline-block;\n    line-height: 0px;\n    margin-left: ', ';\n  }\n'], ['\n  background-image: linear-gradient(45deg, ', ' 0%, ', ' 100%);\n  color: ', ';\n  height: 48px;\n  width: auto;\n  margin: ', ' ', ' ', ' ', ';\n  padding-left: ', ';\n  border-radius: ', ';\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  transition: all 1500ms ease-in-out;\n  span {\n    display: inline-block;\n    line-height: 0px;\n    margin-left: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  0% {\n    width: 0px;\n  }\n  100% {\n    width: props.width;\n  }\n'], ['\n  0% {\n    width: 0px;\n  }\n  100% {\n    width: props.width;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  background-image: linear-gradient(45deg, ', ' 0%, ', ' 100%);\n  color: ', ';\n  height: 100%;\n  width: ', ';\n  padding-left: ', ';\n  position: absolute;\n  left: 0;\n  top: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  transition: all 1500ms ease-in-out;\n'], ['\n  background-image: linear-gradient(45deg, ', ' 0%, ', ' 100%);\n  color: ', ';\n  height: 100%;\n  width: ', ';\n  padding-left: ', ';\n  position: absolute;\n  left: 0;\n  top: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  transition: all 1500ms ease-in-out;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin: ', ';\n  padding-left: ', ';\n  list-style: none;\n  li {\n    display: inline-block;\n    margin-right: ', ';\n    color: ', '\n    &.done {\n     color: ', ';\n    }\n  }\n'], ['\n  margin: ', ';\n  padding-left: ', ';\n  list-style: none;\n  li {\n    display: inline-block;\n    margin-right: ', ';\n    color: ', '\n    &.done {\n     color: ', ';\n    }\n  }\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component, Fragment } from 'react';
import styled, { keyframes } from 'styled-components';
var Container = styled.div(_templateObject, function (props) {
  return props.theme.colours.neutral.light;
}, function (props) {
  return props.theme.colours.neutral.lighter;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return props.theme.spaces.extraLoose;
}, function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return props.theme.padding;
}, function (props) {
  return props.theme.radius;
}, function (props) {
  return props.theme.spaces.tight;
});

var grow = function grow(props) {
  return keyframes(_templateObject2);
};

var Bar = styled.div(_templateObject3, function (props) {
  return props.theme.colours.primary.darkest;
}, function (props) {
  return props.theme.colours.primary.light;
}, function (props) {
  return props.theme.colours.neutral.lightest;
}, function (props) {
  return props.width;
}, function (props) {
  return props.theme.padding;
});
var Description = styled.ul(_templateObject4, function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return props.theme.padding;
}, function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return props.theme.colours.neutral.base;
}, function (props) {
  return props.theme.colours.neutral.darkest;
});

var SiteProgress = function (_Component) {
  _inherits(SiteProgress, _Component);

  function SiteProgress() {
    _classCallCheck(this, SiteProgress);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  SiteProgress.prototype.render = function render() {
    var _props = this.props,
        text = _props.text,
        progress = _props.progress;
    var width = progress + '%';
    return React.createElement(Fragment, null, React.createElement(Container, null, React.createElement('span', null, text), React.createElement(Bar, {
      width: width
    }, React.createElement('span', null, text))));
  };

  return SiteProgress;
}(Component);

export default SiteProgress;